import { ReactNode } from "react"
import Button from "@/components/Button"
import DashboardTopbar from "@/components/DashboardTopbar"
import { PlusIcon } from "@heroicons/react/20/solid"
import AppLayout from "@/layouts/AppLayout"
import { Modals, useModals } from "@/hooks/useModals"
import PlayersList from "@/components/PlayersList"
import AddPlayerModal from "@/modals/AddPlayerModal"

const PlayersIndex = () => {
  const { openModal } = useModals()

  return (
    <>
      <DashboardTopbar title="Players">
        <Button size="sm" onClick={() => openModal(Modals.AddPlayer)}>
          <PlusIcon className="h-5 w-5" />
          <span>Add player</span>
        </Button>
      </DashboardTopbar>

      <PlayersList />

      <AddPlayerModal />
    </>
  )
}

PlayersIndex.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>

export default PlayersIndex
